import React from "react";


const Resume = ({ classicHeader, darkTheme }) => {
  const educationDetails = [
    {
      yearRange: "2011 - 2015",
      title: "Computer Systems & Networking",
      place: "Sri Lanka Institute of Information Technology",
      desc: "Holistic approach for Information Technology domain with specialized study on Systems and Networking.",
    },
    {
      yearRange: "2012 - 2016",
      title: "Professional Qualification in Human Resources Management",
      place: "Chartered Institute of Personnel Management Sri Lanka",
      desc: "Thorough knowledge into all verticals of HR in shaping globally capable HR professional .",
    },
    {
      yearRange: "2020 - 2023",
      title: "Masters in Business Administration ",
      place: "University of Sri Jayawardenapura",
      desc: "The premier MBA program in Sri Lanka ; practical , flexible & focused. Designed to shape Management leaders to be the best. ",
    },
  ];

  const experienceDetails = [
    {
      yearRange: "2015 - 2019",
      title: "Information Technology Executive",
      place: "Ceyoka Pvt Ltd",
      desc: "Managing & developing overall IT function in diversified company cluster.",
    },
    {
      yearRange: "2019 - 2021",
      title: "Systems Engineer",
      place: "IFS Sri Lanka",
      desc: "IT Service Management along with System Administration.",
    },
    {
      yearRange: "2021 - 2023",
      title: "Senior Systems Engineer",
      place: "IFS Sri Lanka",
      desc: "IT Service Management & Modern Workplace Management.",
    },
  ];

  const skills = [
    {
      name: "Modern Workplace Management",
      percent: 85,
    },
    {
      name: "IT Service Managemet",
      percent: 85,
    },
    {
      name: "Office 365",
      percent: 80,
    },
    {
      name: "ITIL",
      percent: 75,
    },
    {
      name: "System Support",
      percent: 85,
    },
    {
      name: "Web Design",
      percent: 70,
    },
  ];

  return (
    <section
      id="resume"
      className={"section " + (darkTheme ? "bg-dark-1" : "")}
    >
      <div className={"container " + (classicHeader ? "" : "px-lg-5")}>
        {/* Heading */}
        <div className="position-relative d-flex text-center mb-5">
          <h2
            className={
              "text-24  text-uppercase fw-600 w-100 mb-0 " +
              (darkTheme ? "text-muted opacity-1" : "text-light opacity-4")
            }
          >
            Summary
          </h2>
          <p
            className={
              "text-9 text-dark fw-600 position-absolute w-100 align-self-center lh-base mb-0 " +
              (darkTheme ? "text-white" : "text-dark")
            }
          >
            {" "}
            Resume
            <span className="heading-separator-line border-bottom border-3 border-primary d-block mx-auto" />
          </p>
        </div>
        {/* Heading end*/}
        <div className="row gx-5">
          {/* My Education */}
          <div className="col-md-6">
            <h2
              className={
                "text-6 fw-600 mb-4 " + (darkTheme ? "text-white" : "")
              }
            >
              My Education
            </h2>
            {educationDetails.length > 0 &&
              educationDetails.map((value, index) => (
                <div
                  key={index}
                  className={
                    "bg-white  rounded p-4 mb-4 " +
                    (darkTheme ? "bg-dark" : "bg-white border")
                  }
                >
                  <p className="badge bg-primary text-2 fw-400">
                    {value.yearRange}
                  </p>
                  <h3 className={"text-5 " + (darkTheme ? "text-white" : "")}>
                    {value.title}
                  </h3>
                  <p className={darkTheme ? "text-primary" : "text-danger"}>
                    {value.place}
                  </p>
                  <p className={"mb-0 " + (darkTheme ? "text-white-50" : "")}>
                    {value.desc}
                  </p>
                </div>
              ))}
          </div>
          {/* My Experience */}
          <div className="col-md-6">
            <h2
              className={
                "text-6 fw-600 mb-4 " + (darkTheme ? "text-white" : "")
              }
            >
              My Experience
            </h2>
            {experienceDetails.length > 0 &&
              experienceDetails.map((value, index) => (
                <div
                  key={index}
                  className={
                    "bg-white  rounded p-4 mb-4 " +
                    (darkTheme ? "bg-dark" : "bg-white border")
                  }
                >
                  <p className="badge bg-primary text-2 fw-400">
                    {value.yearRange}
                  </p>
                  <h3 className={"text-5 " + (darkTheme ? "text-white" : "")}>
                    {value.title}
                  </h3>
                  <p className={darkTheme ? "text-primary" : "text-danger"}>
                    {value.place}
                  </p>
                  <p className={"mb-0 " + (darkTheme ? "text-white-50" : "")}>
                    {value.desc}
                  </p>
                </div>
              ))}
          </div>
        </div>
        {/* My Skills */}
        <h2
          className={
            "text-6 fw-600 mt-4 mb-4 " + (darkTheme ? "text-white" : "")
          }
        >
          My Skills
        </h2>
        <div className="row gx-5">
          {skills.length > 0 &&
            skills.map((skill, index) => (
              <div key={index} className="col-md-6">
                <p
                  className={
                    " fw-500 text-start mb-2 " +
                    (darkTheme ? "text-light" : "text-dark")
                  }
                >
                  {skill.name}{" "}
                  <span className="float-end">{skill.percent}%</span>
                </p>
                <div
                  className={
                    "progress progress-sm mb-4 " + (darkTheme ? "bg-dark" : "")
                  }
                >
                  <div
                    className="progress-bar"
                    role="progressbar"
                    style={{ width: skill.percent + "%" }}
                    aria-valuenow={skill.percent}
                    aria-valuemin={0}
                    aria-valuemax={100}
                  />
                </div>
              </div>
            ))}
        </div>
        <div className="text-center mt-5">
          <a
            className="btn btn-outline-secondary rounded-pill shadow-none"
            href="https://www.linkedin.com/in/poornaabey/"
            target="_blank"
            rel="noreferrer"
          >
            Visit my LinkedIn
            {/* < span className="ms-1">
              <i className="fas fa-download" />
            </span> */}
          </a>
        </div>
      </div>
    </section>
  );
};

export default Resume;
